import {GET_REFERRAL_QUERY} from './GetReferral';

import {GET_REFERRAL_FOR_SHARE_QUERY} from './GetReferralForShare';

export const Queries = {
  GET_REFERRAL_QUERY,
  GET_REFERRAL_FOR_SHARE_QUERY,
};
